package org.example.project.viewmodel

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.example.project.firebase.AuthManager
import org.example.project.firebase.FirestoreManager
import org.example.project.model.User

class UserViewModel {

    var currentUser by mutableStateOf<User?>(null)
        private set

    var isLoading by mutableStateOf(false)
        private set

    var loadError by mutableStateOf<String?>(null)
        private set

    var rank by mutableStateOf(0)
        private set

    private val scope = MainScope()

    fun loadUser() {

        scope.launch {
            isLoading = true
            loadError = null

            val uid = AuthManager.waitForUserId()
            if (uid == null) {
                loadError = "Session expired. Please log in again."
                isLoading = false
                return@launch
            }

            AuthManager.waitForAuthToken()

            // Only create/update profile if user doesn't exist
            val existingUser = FirestoreManager.getUser(uid)
            if (existingUser == null) {
                val email = AuthManager.currentUserEmail() ?: ""
                FirestoreManager.ensureUserProfile(
                    uid = uid,
                    email = email,
                    username = email.substringBefore("@").ifBlank { "Commander" },
                    photoUrl = ""
                )
            }

            var user: User? = null
            repeat(3) { attempt ->
                user = FirestoreManager.getCurrentUser()
                if (user != null) return@repeat
                if (attempt < 2) delay(500)
            }


            currentUser = user
            if(user != null){
                rank = FirestoreManager.getUserRank(user.uid)
            }
            if (user == null) {
                loadError = "Could not load your profile. Please try again."
            }
            isLoading = false
        }
    }

    fun clearUser() {
        currentUser = null
        loadError = null
        isLoading = false
    }
}
